module.exports = __webpack_public_path__ + "img/2010-2.d694b407.jpeg";